import { Text } from "@mantine/core";
import { format } from "date-fns/format";

import { ResultDetail } from "./result-detail";
import { ResultsSection } from "./results-section";
import { QualifyingBadge, UpwageBadge } from "@/components/upwage-badge";
import {
  CompetencyFit,
  type Screening,
  SessionStatus,
} from "@/types/screeners";

interface ScreenerDetailsProps {
  screening: Screening;
}

const TEXT_PROPS = {
  className: "font-semibold",
  size: "sm",
} as const;

export const ScreenerDetails = ({
  screening: {
    createdAt,
    language,
    time,
    words,
    sessionStatus,
    qualifyingSummary,
  },
}: ScreenerDetailsProps) => {
  return (
    <ResultsSection title="Screener details">
      <Text {...TEXT_PROPS}>
        {`Started ${format(createdAt, "LLL d, y 'at' h:mmaaa O")}`}
      </Text>
      {language && <Text {...TEXT_PROPS}>Language: {language}</Text>}
      <Text {...TEXT_PROPS}>
        {time} | {words}
      </Text>
      <ResultDetail
        label="Status"
        value={
          <UpwageBadge
            colorVariant={
              sessionStatus === SessionStatus.Completed
                ? CompetencyFit.VeryHigh
                : CompetencyFit.VeryLow
            }
            filled
          >
            {sessionStatus === SessionStatus.Completed
              ? "COMPLETE"
              : sessionStatus.toUpperCase()}
          </UpwageBadge>
        }
      />
      <ResultDetail
        label="Qualifying score"
        value={
          <QualifyingBadge score={qualifyingSummary?.qualifyingPassRate} />
        }
      ></ResultDetail>
    </ResultsSection>
  );
};
